import { useCallback } from "react";

import useLoginQuery from "../api/useLoginQuery";
import useAuth from "./useAuth";

export default function useLogin() {
    const { onLogin } = useAuth();
    const { loading, error, login } = useLoginQuery();

    const loginCallback = useCallback(
        async (email: string, password: string, onSuccess: () => void) => {
            const result = await login(email, password);
            if (!result.data?.userLogin?.jwt) return;
            onLogin(result.data.userLogin.jwt);
            onSuccess();
        },
        [login, onLogin],
    );

    return {
        loading,
        error,
        login: loginCallback,
    };
}
